import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import i18n from '@/settings/i18n';
import { Label, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

import * as constants from '@/constants';
import { SubscriptionDetail } from '@/types/subscriptions/subscription';
import { pages, formatRoute } from '@/settings/pages';

type Props = {
  subscription: SubscriptionDetail;
};

export const DoneContent: React.FC<Props> = ({ subscription }) => {
  const { t } = useTranslation();
  return (
    <>
      <StyledDetail>
        <Segment className="subsctiption-code-link" padded={true}>
          <div>
            <p>{t('models.subscription.requestCode')}:</p>
            <span
              className="subsctiption-code-link-id"
              data-test="subscription-request-code"
            >
              {subscription.requestCode}
            </span>
          </div>
          <Link
            data-test="subsctiption-code-done-link"
            className="subsctiption-code-link-a"
            to={formatRoute(pages.subscription.detail, {
              requestCode: subscription.requestCode,
            })}
          >
            <Label className="subsctiption-code-link-label">
              {t('text.subscription.codeLink')}
            </Label>
          </Link>
        </Segment>
      </StyledDetail>
      {i18n.languages[0] === 'ja' ? (
        <>
          <p style={{ color: '#dd3a38' }}>
            <Trans i18nKey="text.subscription.done.management">
              <br />
              <a
                href={t('pages.support.hodaiAdmin.url')}
                rel="noopener noreferrer"
                target="_blank"
              >
                link
              </a>
            </Trans>
          </p>
          <p>{t('text.subscription.done.sentMail')}</p>
          <p>
            <Trans i18nKey="text.subscription.done.destination">
              <br />
              <br />
              <br />
            </Trans>
          </p>
          <p>
            <Trans
              i18nKey="text.subscription.done.changeOrCancel"
              values={{ num: constants.INTERVAL_BUSINESS_DAYS + 1 }}
            >
              <br />
              <br />
              <br />
              <br />
              <br />
            </Trans>
          </p>
          <p>{t('text.subscription.done.inquiry')}</p>
        </>
      ) : (
        <>
          <Trans i18nKey="text.subscription.done.sentMail"></Trans>
          <p>
            <Trans i18nKey="text.subscription.done.destination">
              <br />
              <br />
              <br />
            </Trans>
          </p>
          <p>
            <Trans
              i18nKey="text.subscription.done.changeOrCancelAboutHodaiAndUnlimited"
              values={{ num: constants.INTERVAL_BUSINESS_DAYS + 1 }}
            >
              <br />
              <br />
              <a
                href={t('pages.support.hodaiAdmin.url')}
                rel="noopener noreferrer"
                target="_blank"
              >
                link
              </a>
              <br />
            </Trans>
          </p>
          <p>
            <Trans i18nKey="text.subscription.done.changeOrCancelAboutLms">
              <br />
              <br />
            </Trans>
          </p>
          <p>
            <Trans i18nKey="text.subscription.done.changeOrCancelAboutEmba">
              <br />
              <br />
            </Trans>
          </p>
          <p>{t('text.subscription.done.inquiry')}</p>
        </>
      )}
    </>
  );
};

const StyledDetail = styled.div`
  .subsctiption-code-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 2em 0 !important;
  }

  .subsctiption-code-link-id {
    font-size: 1.5em;
  }

  .subsctiption-code-link-a {
    display: block;
  }

  .subsctiption-code-link-label:hover {
    opacity: 0.8;
  }

  .subsctiption-code-link-label {
    padding: 0.75em 1em !important;
    font-size: 1em !important;
  }
`;
